module.exports = __webpack_public_path__ + "static/img/cj07.f66b6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj07.png
// module id = 150
// module chunks = 0